import { handleActions } from 'redux-actions'
import { selectedCapacitation, resetCapacitation } from 'actions/selectedCapacitation'

const defaultState = {
  selectedCapacitation: ''
}

const reducer = handleActions(
  {
    [selectedCapacitation]: (
      state,
      {
        payload: {
          data: { status }
        }
      }
    ) => status,
    [resetCapacitation]: () => defaultState
  },
  defaultState
)

export default reducer
